import { Translation } from '../types';

export const ro: Translation = {
  common: {
    loading: 'Se încarcă...',
    error: 'Eroare',
    cancel: 'Anulează',
    save: 'Salvează',
    close: 'Închide',
    search: 'Caută',
    reload: 'Reîncarcă',
    logout: 'Deconectare',
    dashboard: 'Panou de control',
    products: 'Produse',
    settings: 'Setări',
    language: 'Limbă',
    businessHours: 'Program de lucru',
    back: 'Înapoi',
    selectAll: 'Selectează tot',
    deselectAll: 'Deselectează tot',
    success: 'Succes',
    selected: 'Selectat',
    confirm: 'Confirmă',
    required: 'Obligatoriu',
    requiredMarker: '*',
    previous: 'Anterior',
    next: 'Următor',
    allRightsReserved: 'Toate drepturile rezervate.',
  },
  auth: {
    login: 'Autentificare',
    email: 'Adresă de e-mail',
    password: 'Parolă',
    loginButton: 'Autentificare',
    loggingIn: 'Se autentifică...',
    loginSuccess: 'Autentificare reușită',
    loginError: 'E-mail sau parolă incorectă',
    invalidEmail: 'Vă rugăm să introduceți o adresă de e-mail validă',
    requiredFields: 'Vă rugăm să completați toate câmpurile obligatorii',
    demoAccount: 'Cont demo:',
    loginDescription: 'Introduceți datele contului pentru a vă autentifica',
    welcomeMessage: 'Bun venit în sistemul de comenzi pentru companii',
    // Registration
    register: 'Înregistrare',
    createAccount: 'Creează cont',
    confirmPassword: 'Confirmă parola',
    passwordRequirements: 'Parola trebuie să aibă cel puțin 8 caractere, să conțină litere mari și mici, cifre și caractere speciale',
    passwordsDoNotMatch: 'Parolele nu coincid',
    registrationSuccess: 'Înregistrare reușită',
    registrationDescription: 'Înregistrați un cont de companie',
    alreadyHaveAccount: 'Aveți deja un cont?',
    signIn: 'Autentificare',
    dontHaveAccount: 'Nu aveți un cont?',
    creatingAccount: 'Se creează contul...',
    registrationNote: 'Notă:',
    registrationNotePoints: {
      erpLinking: 'Dacă aveți un cont de companie existent, e-mailul dvs. va fi conectat automat',
      companyEmail: 'Vă rugăm să folosiți adresa de e-mail a companiei pentru înregistrare',
      contactSupport: 'Contactați asistența dacă aveți nevoie de ajutor la înregistrare'
    },
    b2bUsers: 'Utilizatori cont business:',
    registeredEmail: 'Adresă de e-mail înregistrată',
    registeredPassword: 'Parola setată la înregistrare',
    b2bCustomerRequired: 'Această adresă de e-mail nu este înregistrată ca client business. Vă rugăm să contactați departamentul de vânzări pentru a stabili o relație comercială mai întâi.',
    b2bVerificationError: 'Nu s-a putut verifica statutul de client business. Vă rugăm să contactați asistența.',
    // Password Reset
    passwordReset: 'Resetare parolă',
    passwordResetDescription: 'Introduceți adresa de e-mail pentru a primi o parolă temporară',
    getTemporaryPassword: 'Obține parolă temporară',
    processing: 'Se procesează...',
    passwordResetComplete: 'Resetarea parolei a fost finalizată',
    temporaryPasswordGenerated: 'Parola temporară a fost generată',
    temporaryPassword: 'Parolă temporară',
    backToLogin: 'Înapoi la autentificare',
    securityNotice: 'Notă de securitate:',
    securityNotePoints: {
      keepSecret: 'Nu partajați parola temporară cu nimeni',
      changeAfterLogin: 'Asigurați-vă că schimbați parola după autentificare',
      expires24Hours: 'Parola temporară expiră în 24 de ore'
    },
    resetNote: 'Notă:',
    resetNotePoints: {
      registeredEmail: 'Introduceți adresa de e-mail înregistrată',
      passwordDisplayed: 'Parola temporară va fi afișată pe ecran',
      changeRequired: 'Schimbarea parolei este obligatorie după autentificare'
    },
    copied: 'Copiat',
    copySuccessMessage: 'Parola temporară a fost copiată în clipboard.',
    forgotPassword: 'Ați uitat parola?',
    // Password Reset Email Request
    sendResetLink: 'Trimite link de resetare',
    sendingEmail: 'Se trimite e-mailul...',
    emailSent: 'E-mail trimis',
    emailSentMessage: 'Dacă această adresă de e-mail există în sistemul nostru, veți primi în curând un link de resetare.',
    emailNotSent: 'E-mailul nu a fost trimis',
    emailSentInfo: 'Verificați folderul Inbox și Spam',
    checkEmail: 'Verificați e-mailul',
    emailInstructions: 'Instrucțiunile pentru resetarea parolei au fost trimise',
    nextSteps: 'Pașii următori:',
    nextStepsList: {
      checkInbox: 'Verificați folderul Inbox și Spam',
      clickLink: 'Faceți clic pe linkul de resetare din e-mail',
      linkExpires: 'Linkul expiră în 24 de ore',
      contactSupport: 'Contactați asistența dacă nu primiți e-mailul',
      rateLimitInfo: 'Limitat la 3 solicitări pe oră'
    },
    // Password Reset Completion
    resetLinkSent: 'Link de resetare trimis',
    resetSuccess: 'Parola a fost resetată',
    passwordUpdated: 'Parolă actualizată',
    passwordUpdateMessage: 'Parola dvs. a fost actualizată. Acum vă puteți autentifica cu noua parolă.',
    loginWithNewPassword: 'Autentificare cu noua parolă',
    // Reset Token Page
    resetToken: 'Resetare parolă',
    invalidToken: 'Cod de resetare nevalid',
    expiredToken: 'Codul de resetare a expirat',
    tokenValid: 'Codul de resetare este valid',
    newPassword: 'Parolă nouă',
    confirmNewPassword: 'Confirmă parola nouă',
    updatePassword: 'Actualizează parola',
    updatingPassword: 'Se actualizează parola...',
    passwordMismatch: 'Parolele nu coincid',
    resetInstructions: 'Introduceți noua parolă pentru a finaliza resetarea',
  },
  accountInfo: {
    title: 'Informații cont',
    loading: 'Se încarcă informațiile contului...',
    error: 'Eroare',
    errorMessage: 'Nu s-au putut prelua informațiile contului',
    back: 'Înapoi',
    basicInfo: 'Informații de bază',
    name: 'Nume',
    email: 'Adresă de e-mail',
    contactId: 'ID Client Knitido',
    contactNumber: 'Număr de contact',
    noInfo: 'Fără informații',
    companyInfo: 'Informații companie',
    company: 'Numele companiei',
    position: 'Funcție',
    vatId: 'Cod TVA',
    billingAddress: 'Adresă de facturare',
    deliveryAddress: 'Adresă de livrare',
    addressInfo: 'Informații adresă',
    billingDescription: 'Adresa pentru facturi și documente contractuale',
    deliveryDescription: 'Adresa de livrare implicită pentru expedieri de produse',
    sameAsBilling: '※ Aceeași cu adresa de facturare',
    sameAsDelivery: '※ Aceeași cu adresa de livrare',
    companyName: 'Numele companiei',
    contactPerson: 'Persoană de contact',
    address: 'Adresă',
    phoneNumber: 'Număr de telefon',
    billingUsage: 'Utilizată pentru facturi, contracte și alte documente importante',
    deliveryUsage: 'Utilizată ca adresă de livrare implicită pentru produsele comandate',
    alsoUsedForDelivery: 'Utilizată și ca destinație de livrare',
    accountType: 'Tip de cont',
    addressId: 'ID Adresă',
    // Address editing functionality
    edit: 'Editează',
    editDeliveryAddress: 'Editează adresa de livrare',
    editDeliveryDescription: 'Actualizați informațiile adresei de livrare',
    newDeliveryAddress: 'Adaugă adresă de livrare nouă',
    newDeliveryDescription: 'Introduceți detaliile noii adrese de livrare',
    noDeliveryAddress: 'Nicio adresă de livrare configurată',
    success: 'Succes',
    addressUpdated: 'Adresa de livrare a fost actualizată',
    updateError: 'Nu s-a putut actualiza adresa de livrare',
    requiredFields: 'Vă rugăm să completați toate câmpurile obligatorii',
    firstName: 'Prenume',
    lastName: 'Nume de familie',
    streetAddress: 'Adresă (stradă și număr)',
    streetAddress2: 'Adresă (continuare)',
    city: 'Oraș',
    country: 'Țară',
    selectCountry: 'Selectați țara...',
    searchCountry: 'Căutați țara...',
    noCountryFound: 'Nu s-a găsit nicio țară.',
    postalCode: 'Cod poștal',
    companyNamePlaceholder: 'Introduceți numele companiei',
    firstNamePlaceholder: 'Prenume',
    lastNamePlaceholder: 'Nume de familie',
    streetAddressPlaceholder: 'Introduceți adresa',
    streetAddress2Placeholder: 'Apartament, scară, etc.',
    cityPlaceholder: 'Introduceți orașul',
    postalCodePlaceholder: 'Introduceți codul poștal',
    billingNotEditable: 'Adresa de facturare nu poate fi editată.',
    billingContactSupport: 'Contactați asistența pentru modificări.',
    // Multiple delivery addresses
    deliveryAddressCount: '{count} adrese de livrare',
    noDeliveryAddresses: 'Nicio adresă de livrare înregistrată',
    defaultAddress: 'Implicită',
    selectDeliveryAddress: 'Selectați adresa de livrare',
    addNewAddress: 'Adaugă adresă nouă',
    editAddress: 'Editează adresa',
    deleteAddress: 'Șterge adresa',
    confirmDelete: 'Confirmă ștergerea',
    confirmDeleteMessage: 'Sigur doriți să ștergeți această adresă? Această acțiune este ireversibilă.',
    addressAddedSuccess: 'Adresă de livrare adăugată',
    addressDeletedSuccess: 'Adresă de livrare ștearsă',
    deleteError: 'Nu s-a putut șterge adresa de livrare',
    saving: 'Se salvează...',
    cancel: 'Anulează',
    saveChanges: 'Salvează modificările',
    selectedDeliveryAddress: 'Adresă de livrare selectată',
  },
  dashboard: {
    title: 'Partener Comercial',
    subtitle: 'Sistem Comenzi Produse',
    welcome: 'Bun venit,',
    welcomeMessage: 'Bun venit în sistemul de comenzi pentru parteneri comerciali. Puteți comanda produse aici.',
    productCatalog: 'Catalog Produse',
    productCatalogDesc: 'Răsfoiți și comandați produsele disponibile',
    viewProducts: 'Vezi produse',
    orderHistory: 'Istoric Comenzi',
    orderHistoryDesc: 'Vizualizați comenzile anterioare',
    accountSettings: 'Setări Cont',
    accountSettingsDesc: 'Gestionați informațiile contului',
    comingSoon: 'În curând',
    infoTitle: 'Despre utilizare',
    orderingInfo: 'Comandarea produselor',
    orderingDesc: 'Selectați produsele din catalog și specificați mărimea și culoarea. Informațiile despre stoc sunt disponibile în timp real.',
    supportInfo: 'Asistență',
    supportDesc: 'Contactați-ne dacă aveți întrebări.',
    viewOrderHistory: 'Vezi istoricul comenzilor',
    viewOrders: 'Vezi comenzi',
    accountInfo: 'Informații cont',
    accountInfoDesc: 'Vizualizați detaliile contului',
    viewDetails: 'Vezi detalii',
    supportEmail: 'b2b-partner@knitido.de',
    supportPhone: '+49(0)30 6640 9300',
    businessHours: 'Luni-Vineri 9:00 - 15:00 CET',
    bulkImportDesc: 'Importați comenzi din fișiere Excel/CSV',
    importOrders: 'Importă comenzi',
  },
  products: {
    title: 'Listă Produse',
    subtitle: 'Partener Comercial',
    searchPlaceholder: 'Căutați după numele produsului sau SKU...',
    productId: 'ID Produs',
    addToCart: 'Adaugă în coș',
    selectVariation: 'Selectați varianta',
    price: 'Preț',
    priceNetNotice: 'Toate prețurile sunt fără TVA',
    stock: 'Stoc',
    color: 'Culoare',
    newProducts: 'Produse Noi',
    newProductBadge: 'NOU',
    size: 'Mărime',
    quantity: 'Cantitate',
    total: 'Total',
    cart: 'Coș',
    checkout: 'Finalizare comandă',
    csvMode: 'Mod rapid CSV',
    csvInfo: 'Date produse preluate din datele CSV',
    csvUploadDate: 'Dată încărcare CSV:',
    stockNote: '※ Informațiile despre stoc sunt preluate la selectarea variantelor de produs',
    noProducts: 'Nu s-au găsit produse',
    noProductsDesc: 'Modificați criteriile de căutare sau încărcați un fișier CSV pentru o performanță mai bună.',
    retry: 'Reîncearcă',
    pagination: 'elemente',
    variations: 'variante',
    stockFetchError: 'Eroare preluare stoc',
    stockFetchFailed: 'Preluarea stocului a eșuat',
    stockFetchFailedDesc: 'Nu s-au putut prelua informațiile despre stoc. Va fi afișat stocul din CSV.',
    stockFetched: 'Informații stoc preluate',
    totalStock: 'Stoc total',
    noStockAll: 'Toate variantele au stoc zero',
    noStockData: 'Nu au fost returnate date despre stoc',
    stockFetchErrorDesc: 'A apărut o eroare la preluarea informațiilor despre stoc',
    selectionError: 'Eroare selecție',
    enterQuantity: 'Vennligst oppgi antall',
    addedToCart: 'Adăugat în coș',
    typesAdded: ' tipuri de produse adăugate',
    addToCartError: 'Eroare la adăugare în coș',
    addToCartErrorDesc: 'Vă rugăm încercați din nou',
    loadingStock: 'Se încarcă informațiile despre stoc',
    csvDataInfo: 'Se afișează informații din datele CSV (nu nivelurile reale de stoc)',
    invalidDataFormat: 'Formatul datelor despre produs este nevalid',
    loadFailed: 'Nu s-au putut încărca datele despre produs',
    csvUploadComplete: 'Încărcare CSV finalizată',
    csvLoadedDesc: ' date produse încărcate. Informațiile despre stoc vor fi preluate la selectarea produselor.',
    searchTitle: 'Căutare Produse',
    loadingProducts: 'Se încarcă datele despre produse',
    noProductsCsv: 'Nu s-au găsit produse în datele CSV. Vă rugăm să modificați criteriile de căutare.',
    paginationDisplay: ' afișate',
    previous: 'Anterior',
    next: 'Următor',
    selectionSummary: 'Sumar selecție',
    selectedQuantity: 'Cantitate selectată',
    items: ' elemente',
    viewDetails: 'Vezi detalii',
    productImage: 'Imagine produs',
    correspondingVariations: 'Variante corespunzătoare',
    clickToEnlarge: 'Faceți clic pentru a mări',
    productIdLabel: 'ID Produs',
    colorLabel: 'Culoare',
    filterByCategory: 'Filtrează după categorie',
    allProducts: 'Toate produsele',
    applyFilters: 'Aplică filtre',
    clearFilters: 'Șterge filtrele',
    filters: 'Filtre',
    clearAll: 'Șterge tot',
  },
  categories: {
    category_21: 'Șosete cu degete',
    category_23: 'Necategorizate',
    category_24: 'Îmbrăcăminte corp',
    category_29: 'Produse B2B',
  },
  productDetail: {
    title: 'Detalii Produs',
    backToProducts: 'Înapoi la produse',
    productNotFound: 'Produsul nu a fost găsit',
    productNotFoundDesc: 'Produsul specificat nu există sau a fost șters.',
    loading: 'Se încarcă produsul...',
    imageLoadError: 'Nu s-au putut încărca imaginile',
    noImages: 'Nicio imagine disponibilă',
    productDescription: 'Descriere produs',
    colors: 'Culori',
    sizes: 'Mărimi',
    colorCount: 'culori',
    sizeCount: 'mărimi',
    variationCount: 'variante',
    selectVariation: 'Selectați variantele',
    descriptionLanguageNote: '※ Descrierile produselor sunt disponibile doar în engleză sau germană',
  },
  colors: {
    schwarz: 'Negru',
    weiß: 'Alb',
    grau: 'Gri',
    rot: 'Roșu',
    blau: 'Albastru',
    grün: 'Verde',
    gelb: 'Galben',
    rosa: 'Roz',
    lila: 'Violet',
    braun: 'Maro',
    orange: 'Portocaliu',
    beige: 'Bej',
    navy: 'Bleumarin',
    dunkelblau: 'Albastru închis',
    hellblau: 'Albastru deschis',
    dunkelgrau: 'Gri închis',
    hellgrau: 'Gri deschis',
    bordeaux: 'Bordeaux',
    türkis: 'Turcoaz',
    khaki: 'Kaki',
    mint: 'Mentă',
    violett: 'Violet',
    anthrazit: 'Antracit',
    blaugrau: 'Gri-albăstrui',
    burgunderrot: 'Burgund',
    elfenbein: 'Fildeș',
    karminrot: 'Roșu carmin',
    neongrün: 'Verde neon',
    gelbgrün: 'Verde-gălbui',
    pistazie: 'Fistic',
    // Nume culori în engleză
    blue: 'Albastru',
    ivory: 'Fildeș',
    green: 'Verde',
    gold: 'Auriu',
    red: 'Roșu',
  },
  checkout: {
    title: 'Finalizare comandă',
    cartReview: 'Recapitulare comandă',
    orderSummary: 'Sumar comandă',
    shippingInfo: 'Informații livrare',
    billingInfo: 'Informații facturare',
    orderNotes: 'Note comandă',
    orderNotesPlaceholder: 'Solicitări speciale sau note...',
    contactPerson: 'Persoană de contact',
    phoneNumber: 'Număr de telefon',
    email: 'Adresă de e-mail',
    company: 'Companie',
    address: 'Adresă',
    city: 'Oraș',
    postalCode: 'Cod poștal',
    country: 'Țară',
    deliveryDate: 'Dată livrare',
    urgentDelivery: 'Livrare expres (3-5 zile lucrătoare)',
    standardDelivery: 'Livrare standard (7-10 zile lucrătoare)',
    placeOrder: 'Trimite comanda',
    backToCart: 'Înapoi la selecția produselor',
    requiredField: 'Câmp obligatoriu',
    orderTotal: 'Total comandă',
    subtotal: 'Subtotal',
    priceNetNotice: 'Toate prețurile sunt fără TVA',
    stockReservationNotice: 'Rezervarea stocului se va face după confirmarea comenzii.',
    stockCheckError: 'Eroare verificare stoc',
    stockCheckErrorDesc: 'A apărut o eroare la verificarea stocului. Vă rugăm să reîncercați.',
    shipping: 'Transport',
    shippingCost: 'Cost transport',
    tax: 'TVA',
    orderSuccess: 'Comandă trimisă cu succes',
    orderSuccessMessage: 'Comanda dvs. a fost trimisă. Număr comandă: {orderNumber}',
    orderNumber: 'Număr comandă',
    thankYou: 'Vă mulțumim pentru comandă!',
    orderConfirmation: 'Comanda dvs. a fost trimisă.',
    orderProcessing: 'După revizuirea de către echipa noastră, vă vom trimite o confirmare a comenzii prin e-mail.',
    orderProcessingMessage: 'Comanda dvs. a fost trimisă. După revizuirea de către echipa noastră, vă vom trimite o confirmare a comenzii prin e-mail.',
    continueShopping: 'Continuă cumpărăturile',
    emptyCart: 'Coșul dvs. este gol',
    emptyCartMessage: 'Vă rugăm să adăugați produse în coș pentru a continua',
    stockWarning: 'Avertisment stoc',
    stockWarningDesc: 'Unele articole au stoc insuficient. Vă rugăm să ajustați cantitățile.',
    stockError: 'Eroare stoc',
    stockErrorDesc: 'Există articole cu stoc insuficient. Vă rugăm să ajustați cantitățile.',
    refreshStock: 'Actualizează stocul',
    stockUpdated: 'Stoc actualizat',
    stockUpdatedDesc: 'Stocul a fost actualizat - {changed} articole modificate',
    stockCheckDesc: 'Rezultatele comparării cu stocul sunt afișate',
    stockOk: 'Stoc OK',
    stockShortage: 'Lipsă stoc',
    requestedQty: 'Cantitate solicitată',
    currentStock: 'Stoc actual',
    stockShortageMsg: 'Stoc insuficient. Vă rugăm să ajustați cantitatea.',
    stockIssueWarning: 'Comanda nu poate fi confirmată din cauza problemelor de stoc.',
    stockDataMissing: 'Se preiau datele despre stoc. Vă rugăm să așteptați un moment.',
    outOfStock: 'Stoc epuizat.',
    maxAvailable: 'Maxim',
    autoRestored: 'Coș restaurat',
    autoRestoredDesc: 'Articolele din ultima dvs. sesiune au fost restaurate',
    maxQuantityReached: 'Cantitatea maximă în stoc a fost atinsă.',
    // ERP Contact Search
    contactSearch: 'Căutare contact client',
    contactSearchDesc: 'Introduceți adresa de e-mail a persoanei care comandă pentru a prelua informațiile de contact',
    emailAddress: 'Adresă de e-mail',
    searchButton: 'Caută',
    searching: 'Se caută',
    contactFound: 'Contact găsit',
    contactNotFound: 'Contactul nu a fost găsit',
    contactId: 'ID Client Knitido',
    companyName: 'Companie',
    contactPersonLabel: 'Persoană de contact',
    addressesFound: 'Adrese găsite',
    addressType: 'Tip',
    addressBilling: 'Adresă facturare',
    addressDelivery: 'Adresă livrare',
    vatSourceCompany: 'Info companie',
    vatSourceBilling: 'Facturare',
    vatSourceDelivery: 'Livrare',
    addressOther: 'Altele',
    addressDetails: 'Adresă',
    loadingAddresses: 'Se încarcă informațiile adresei...',
    addressRetrieved: 'Informații adresă preluate',
    addressNotFound: 'Informațiile adresei nu au fost găsite',
    addressNotFoundDesc: 'Nicio informație despre adresă înregistrată. Vă rugăm să introduceți manual.',
    addressError: 'Eroare preluare adresă',
    addressErrorDesc: 'Nu s-au putut prelua informațiile adresei.',
    contactNotConfirmed: 'Contactul clientului nu a fost confirmat',
    contactNotConfirmedDesc: 'Vă rugăm să introduceți o adresă de e-mail și să căutați contactul.',
    searchContact: 'Caută contact',
    inputError: 'Eroare date introduse',
    inputErrorDesc: 'Informațiile de livrare sunt incomplete. Vă rugăm să verificați.',
    processing: 'Se procesează...',
    erpContactSearch: 'Căutare contact client',
    contactSearchError: 'Adresa de e-mail nu corespunde niciunui contact înregistrat.',
    // Product Images Toggle
    showProductImages: 'Arată imaginile produselor',
    showProductImagesDesc: 'Afișează imaginile produselor pentru o privire de ansamblu mai bună (poate crește timpul de încărcare)',
    // System Registration Info
    systemRegistrationInfo: 'Informațiile dvs. de client',
    editShippingAddress: 'Editează adresa de livrare',
    systemRegistrationInfoDesc: 'Informațiile dvs. de companie înregistrate. Vă rugăm să contactați reprezentantul dacă trebuie să actualizați detaliile adresei de facturare.',
    // Order Summary
    regularPrice: 'Preț angro obișnuit',
    offeredPrice: 'Preț oferit',
    discount: 'Reducere',
    b2bCustomer: 'Client B2B',
    pattern: 'Model',
    specialPriceApplied: 'Preț special aplicat',
    customerClassification: 'Clasificarea clientului',
    paymentCondition: 'Condiții de plată',
    invoice: 'Factură (NET 30)',
    prepayment: 'Plată în avans',
    paymentMethod: 'Metodă de plată',
    invoicePayment: 'Plată prin factură',
    estimatedSubtotal: 'Subtotal estimat',
    estimatedTotal: 'Total estimat',
    orderSummaryDisclaimer: 'Prețurile afișate aici sunt estimative. După ce primim comanda, o vom revizui și vă vom trimite prin e-mail o confirmare a comenzii cu prețurile finale, costurile de transport și taxele.',
    searchError: 'Eroare căutare',
    searchErrorDesc: 'A apărut o eroare în timpul căutării contactului.',
    confirmDeleteItem: 'Elimină articolul',
    itemDeleted: 'Articol eliminat',
    confirmDeleteItemDesc: 'Sigur doriți să eliminați următorul articol din coș?',
    deleteConfirm: 'Elimină',
    contactNotes: 'Note contact',
    contactNotesDesc: 'Aveți întrebări sau solicitări speciale? Anunțați-ne (opțional)',
    contactNotesLabel: 'Mesaj',
    contactNotesPlaceholder: 'de ex.: Întrebări despre produse, cerințe speciale etc.',
    characters: 'caractere',
    contactIdLabel: 'ID Client Knitido',
    companyLabel: 'Companie',
    personLabel: 'Persoană de contact',
    emailLabel: 'E-mail',
    addressTypeLabel: 'Tip',
    destinationLabel: 'Destinație',
    // Shipping Form
    shippingTitle: 'Informații livrare',
    shippingDesc: 'Introduceți adresa de livrare pentru produse',
    companyRequired: 'Companie *',
    contactPersonRequired: 'Persoană de contact *',
    emailRequired: 'Adresă de e-mail *',
    phoneRequired: 'Număr de telefon *',
    addressRequired: 'Adresă 1 *',
    address2: 'Adresă 2 (Clădire/Cameră)',
    postalCodeRequired: 'Cod poștal *',
    cityRequired: 'Oraș *',
    countryRequired: 'Țară *',
    selectCountry: 'Selectați țara',
    shippingMethodRequired: 'Metodă de livrare *',
    selectShippingMethod: 'Selectați metoda de livrare',
    urgentDeliveryOption: 'Livrare urgentă (costuri suplimentare)',
    deliveryNotes: 'Note livrare',
    deliveryNotesPlaceholder: 'Specificați preferințele pentru timpul de livrare sau alte solicitări',
    standardShipping: 'Transport standard (3-5 zile lucrătoare)',
    expressShipping: 'Transport expres (1-2 zile lucrătoare)',
    overnightShipping: 'Livrare peste noapte',
    germany: 'Germania',
    austria: 'Austria',
    switzerland: 'Elveția',
    japan: 'Japonia',
    shippingAddressLabel: 'Adresă livrare',
    changeDeliveryAddress: 'Schimbă adresa de livrare',
    selectDeliveryAddress: 'Selectați adresa de livrare',
    // Shipping Cost Details
    freeShipping: 'Transport gratuit',
    shippingError: 'Eroare',
    shippingZone: 'Zonă de transport',
    remainingForFreeShipping: '{amount} rămase pentru transport gratuit',
    moreForFreeShipping: 'mai mult pentru transport gratuit',
    freeShippingProgress: 'Transport gratuit la',
    andAboveFreeShipping: 'și peste pentru transport gratuit',
    freeShippingAchieved: 'Transport gratuit aplicat',
    threshold: 'și peste',
    nextShippingTier: 'Următoarea reducere la transport',
    moreForDiscount: 'mai mult pentru',
    shippingSavings: 'economii la transport',
    orderAmountThreshold: 'și peste pentru',
    specialRegionNotice: 'Zonă specială de transport aplicată',
    defaultShippingApplied: 'Tarife de transport standard aplicate',
    requestedQuantity: 'Cantitate solicitată',
    availableQuantity: 'Cantitate disponibilă',
    orderSubmitError: 'Eroare comandă',
    orderSubmitErrorDesc: 'Nu s-a putut trimite comanda',
    upload: {
      title: 'Importă comandă Excel/CSV',
      description: 'Încărcați un fișier Excel sau CSV cu datele comenzii',
      dragDropOrClick: 'Trageți fișierul aici sau faceți clic pentru a selecta',
      dropHere: 'Eliberați fișierul aici',
      supportedFormats: 'Formate acceptate: Excel (.xlsx, .xls) și CSV (.csv)',
      maxSize: 'Dimensiune maximă fișier: {size} MB',
      processFile: 'Procesează fișierul',
      processing: 'Se procesează fișierul...',
      ready: 'Fișier gata pentru previzualizare',
      readyDescription: 'Fișierul a fost procesat și este gata pentru revizuire.',
      preview: 'Vezi previzualizare',
      errors: {
        fileTooLarge: 'Fișierul este prea mare. Dimensiune maximă: {size} MB',
        invalidFileType: 'Tip de fișier nevalid. Vă rugăm să încărcați un fișier Excel sau CSV',
        uploadFailed: 'Eroare la încărcarea fișierului',
      },
    },
    // Loading messages
    loadingPage: 'Se încarcă pagina...',
    loadingStock: 'Se verifică stocul produselor...',
    loadingAccount: 'Se încarcă informațiile contului...',
    loadingError: 'A apărut o eroare...',
    loadingData: 'Se încarcă datele',
    // Toast messages
    addressRetrievedTitle: 'Informații adresă preluate',
    addressSetAsDelivery: ' adresa setată ca destinație de livrare.',
    contactFoundDesc: ' a fost recunoscut.'
  },
  orderHistory: {
    title: 'Istoric Comenzi',
    searchPlaceholder: 'Căutați după numărul comenzii sau SKU...',
    noOrders: 'Nu s-au găsit comenzi',
    noOrdersFound: 'Nu s-au găsit comenzi corespunzătoare',
    startShopping: 'Vezi produse',
    orderItems: 'Articole comandă',
    viewDetails: 'Detalii',
    reorder: 'Comandă din nou',
    orderDate: 'Dată comandă',
    orderStatus: 'Statut',
    orderTotal: 'Total comandă',
    // Status translations
    statusPending: 'În așteptarea plății',
    statusProcessing: 'Se procesează',
    statusConfirmed: 'Confirmată',
    statusShipped: 'Expediată',
    statusDelivered: 'Livrată',
    statusCancelled: 'Anulată',
    statusReturned: 'Returnată',
    statusRefunded: 'Rambursată',
    statusWarranty: 'Garanție',
    statusExchanged: 'Schimbată',
    statusRepair: 'Reparație',
    statusUnknown: 'Necunoscut',
    statusIncomplete: 'Incompletă',
    statusWaitingPayment: 'În așteptarea plății',
    statusInPreparation: 'În pregătire',
    statusClearedShipping: 'Gata de expediere',
    statusBeingShipped: 'Se expediază',
    statusOutgoingBooked: 'Rezervată pentru expediere',
    statusReturn: 'Retur',
    // Additional UI elements
    itemCount: 'articole',
    itemCountSingular: 'articol',
    refreshButton: 'Actualizează',
    errorFetchingOrders: 'Nu s-a putut prelua istoricul comenzilor',
    // Payment status features
    paymentStatus: 'Statut plată',
    markAsPaid: 'Marchează ca plătită',
    unmarkAsPaid: 'Elimină marcajul de plată',
    paidOn: 'Plătită la',
    paymentMarked: 'Plătită',
    notPaid: 'Neplătită',
    paymentMarkedSuccess: 'Marcată cu succes ca plătită',
    paymentUnmarkedSuccess: 'Marcajul de plată a fost eliminat',
    paymentUpdateError: 'Nu s-a putut actualiza statutul plății',
    // Payment date dialog
    paymentDateTitle: 'Introduceți informațiile de plată',
    paymentDateDescription: 'Introduceți informațiile de plată pentru comanda {orderNumber}',
    paymentDateLabel: 'Dată plată',
    selectDate: 'Selectați data',
    paymentDateHelp: 'Selectați data la care a fost efectuat viramentul bancar',
    paymentMethodLabel: 'Metodă de plată',
    bankTransfer: 'Virament bancar',
    invoice: 'Factură',
    otherPayment: 'Altele',
    paymentReferenceLabel: 'Nume virament / Număr referință',
    paymentReferencePlaceholder: 'de ex. Ion Popescu, Virament #12345',
    paymentReferenceHelp: 'Introduceți informații care ajută la potrivirea cu extrasul de cont',
    notesLabel: 'Note',
    notesPlaceholder: 'Introduceți orice informație suplimentară despre plată',
    // Filter options
    filterByPaymentStatus: 'Filtrează după statutul plății',
    allOrders: 'Toate comenzile',
    paidOrders: 'Plătite',
    unpaidOrders: 'Neplătite',
    // Sorting options
    sortBy: 'Sortează după',
    sortByDate: 'Dată comandă',
    sortByPaymentDate: 'Dată plată',
    sortByAmount: 'Sumă',
    sortByStatus: 'Statut',
  },
  orderDetails: {
    title: 'Detalii Comandă',
    notFound: 'Comanda nu a fost găsită',
    backToHistory: 'Înapoi la istoricul comenzilor',
    orderDate: 'Dată comandă',
    orderItems: 'Articole comandă',
    deliveryStatus: 'Statut livrare',
    estimatedDelivery: 'Livrare estimată',
    deliveredOn: 'Livrată la',
    downloadInvoice: 'Descarcă factura',
    statusDelivered: 'Livrată',
    statusShipped: 'Expediată',
    statusConfirmed: 'Confirmată',
    statusCancelled: 'Anulată',
    errorFetchingDetails: 'Nu s-au putut prelua detaliile comenzii',
  },
  company: {
    name: 'Partener Comercial',
    tagline: 'Sistem Partener Comercial',
    copyright: '© 2025 Sistem Partener Comercial. Toate drepturile rezervate.',
  },
  footer: {
    phone: 'Telefon',
    email: 'E-post',
    countries: {
      DE: 'Germania',
      AT: 'Austria',
      CH: 'Elveția',
      FR: 'Franța',
      IT: 'Italia',
      ES: 'Spania',
      NL: 'Țările de Jos',
      BE: 'Belgia',
      PL: 'Polonia',
      SE: 'Sverige',
      NO: 'Norvegia',
      FI: 'Finland',
      DK: 'Danmark',
      LT: 'Lituania',
      LV: 'Letonia',
      EE: 'Estonia',
    },
  },
  cart: {
    newCart: 'Coș nou',
    currentCart: 'Coș curent',
    modified: 'modificat',
    lastSaved: 'Ultima salvare',
    unsavedChanges: 'modificări nesalvate',
    saveCart: 'Salvează coșul',
    loadCart: 'Încarcă coșul',
    deleteCart: 'Șterge coșul',
    startNewCart: 'Începe coș nou',
    savedCarts: 'Coșuri salvate',
    cartSaved: 'Coș salvat',
    cartDeleted: 'Coș șters',
    confirmDeleteCart: 'Ștergeți coșul?\n\nAceastă acțiune este ireversibilă.',
    confirmSwitchCart: 'Coșul curent are modificări nesalvate.\n\nÎncărcarea altui coș va duce la pierderea modificărilor curente.\n\nContinuați?',
    confirmSwitchCartTitle: 'Schimbă coșul',
    confirmNewCart: 'Coșul curent are modificări nesalvate.\n\nÎnceperea unui coș nou va duce la pierderea modificărilor curente.\n\nContinuați?',
    confirmNewCartTitle: 'Începe coș nou',
    confirmClearCart: 'Goliți coșul?\n\n{count} articole vor fi eliminate.\n\nAceastă acțiune este ireversibilă.',
    confirmClearCartTitle: 'Golește coșul',
    autoSaved: 'Salvat automat',
    itemsWillBeRemoved: 'articole vor fi eliminate',
    changesWillBeLost: 'modificările vor fi pierdute',
    continueQuestion: 'Continuați?',
    cartStatus: 'Statut coș',
    cartName: 'Nume coș',
    cartNamePlaceholder: 'de ex.: Comandă sfârșit de lună',
    cartNameRequired: 'Vă rugăm să introduceți un nume pentru coș',
    saveCartDescription: 'Dați un nume coșului curent și salvați-l. Îl puteți încărca mai târziu.',
    cancelCart: 'Anulează coșul',
    proceedToCheckout: 'Continuă spre finalizare',
    emptyCart: 'Coșul este gol',
    erpDown: 'Sistemul de comenzi este oprit. Vă rugăm să încercați din nou mai târziu.',
    erpDegraded: 'Sistemul este în prezent instabil. Comenzile pot eșua.',
    erpDownSaveHint: 'Salvați coșul și comandați după ce sistemul este restaurat.',
    erpSaveCart: 'Salvează coșul',
  },
  nav: {
    dashboard: 'Panou de control',
    products: 'Produse',
    orderHistory: 'Comenzi',
    account: 'Informații cont',
    bulkImport: 'Import masiv',
  },
  settings: {
    selectLanguage: 'Selectați o limbă',
    languagePreferenceSaved: 'Alegerea dvs. va fi salvată în cont pentru vizitele viitoare.',
  },
  reorder: {
    allItemsAdded: '{count} articole adăugate în coș',
    partialSuccess: '{added} articole adăugate. {failed} articole nu au putut fi adăugate',
    allItemsFailed: 'Nu s-au putut adăuga articolele în coș',
    error: 'A apărut o eroare în timpul re-comandării',
    itemDiscontinued: '{name} ({color}/{size}) nu mai este disponibil',
    itemOutOfStock: '{name} ({color}/{size}) nu mai este în stoc',
    partialStock: '{name} ({color}/{size}) doar {available} disponibile',
    confirmReorder: 'Confirmă re-comandarea',
    confirmReorderMessage: 'Adăugați articolele din această comandă în coș?',
    addingToCart: 'Se adaugă în coș...',
    checkingStock: 'Se verifică stocul...',
    checkoutTitle: 'Articole adăugate în coș',
    checkoutDescription: '{count} articole au fost adăugate în coș. Doriți să mergeți la finalizarea comenzii?',
  },
  bulkImport: {
    instructions: 'Cum se importă comenzile',
    step1: 'Descărcați fișierul șablon pentru comenzi',
    step2: 'Completați datele comenzii cu SKU și cantitate',
    step3: 'Salvați ca fișier Excel (.xlsx) sau CSV',
    step4: 'Încărcați fișierul folosind formularul de mai jos',
    step5: 'Revizuiți și confirmați comanda',
    downloadTemplate: 'Descărcă șablonul',
    downloadExcelTemplate: 'Descărcă șablonul Excel',
    downloadCsvTemplate: 'Descărcă șablonul CSV',
    formatGuide: 'Ghid format fișier',
    requiredColumns: 'Coloane obligatorii',
    skuDescription: 'Codul SKU al produsului',
    quantityDescription: 'Cantitatea comandată (număr întreg pozitiv)',
    optionalColumns: 'Coloane opționale',
    notesDescription: 'Note interne (de ex. număr PO, referință) - doar pentru evidența dvs.',
    formatNote: 'Prima linie trebuie să conțină antetele coloanelor. Datele încep de la linia a doua.',
    parseSuccess: 'S-au procesat cu succes {count} articole din fișier',
    parseError: 'Eroare de procesare',
    validationError: 'Eroare de validare',
    validationErrorGuidance: 'Vă rugăm să faceți clic pe butonul "{showPreviewButton}" pentru a revizui detaliile.',
    warnings: 'Avertismente',
    itemsParsed: 'S-au procesat cu succes {count} articole:',
    andMore: '...și încă {count} articole',
    validationSummary: 'Sumar validare',
    duplicateSKUs: 'S-au găsit SKU-uri duplicate',
    skuFormat: 'SKU-ul trebuie să conțină doar litere, cifre și cratime',
    quantityRange: 'Cantitatea trebuie să fie între 1 și 9999',
    maxRows: 'Maximum 1000 de rânduri permise',
    rowsSkipped: '{count} rânduri au fost omise din cauza erorilor',
    previewTitle: 'Previziune comandă',
    previewDescription: 'Revizuiți și editați datele comenzii înainte de a continua',
    proceedToCart: 'Adaugă în coș',
    // File parsing messages
    fileEmpty: 'Fișierul este gol sau nu conține date',
    fileTooManyRows: 'Fișierul conține prea multe rânduri ({current}). Maxim permis: {max}',
    invalidRowFormat: 'Format rând nevalid',
    missingColumns: 'Lipsesc coloanele obligatorii (SKU și Cantitate)',
    missingSku: 'Lipsește SKU',
    invalidSkuFormat: 'Format SKU nevalid: "{sku}" (trebuie să respecte modelul: {pattern})',
    skuTooLong: 'SKU prea lung: "{sku}" (maximum 50 caractere)',
    invalidQuantity: 'Cantitate nevalidă: "{quantity}" nu este un număr',
    quantityTooLow: 'Cantitate prea mică: {quantity} (minim: {min})',
    quantityTooHigh: 'Cantitate prea mare: {quantity} (maxim: {max})',
    notesRequired: 'Câmpul de note este obligatoriu',
    noValidData: 'Nu s-au găsit date valide. Vă rugăm să verificați formatul fișierului.',
    row: 'Rândul {row}: {errors}',
    rowErrors: '...și încă {count} erori',
    duplicateSkuInRows: 'SKU duplicat "{sku}" găsit în rândurile: {rows}',
    quantityExceedsMax: 'Rândul {row}: Cantitatea {quantity} depășește maximul permis ({max})',
    quantityBelowMin: 'Rândul {row}: Cantitatea {quantity} este sub minimul necesar ({min})',
    // Validation messages
    unsupportedFileFormat: 'Format de fișier neacceptat. Vă rugăm să încărcați un fișier CSV sau Excel.',
    csvParsingErrors: 'Au apărut erori la procesarea CSV',
    failedToParseFile: 'Nu s-a putut procesa fișierul',
    failedToParseExcel: 'Nu s-a putut procesa fișierul Excel',
    failedToReadFile: 'Nu s-a putut citi fișierul',
    unknownError: 'A apărut o eroare necunoscută',
    totalRows: 'Total rânduri',
    valid: 'Valide',
    invalid: 'Nevalide',
    skipped: 'Omise',
    // SKU validation
    skuValidationError: 'Eroare validare SKU',
    skuValidationFailed: 'Nu s-au putut valida SKU-urile. Puteți continua, dar este posibil ca unele articole să nu fie disponibile.',
    skuNotFound: 'SKU-ul nu a fost găsit în baza de date',
    skusNotFound: '{count} SKU-uri nu au fost găsite în baza de date',
    itemsHaveInsufficientStock: '{count} articole au stoc insuficient',
    validatingSKUs: 'Se validează articolele...',
    unvalidatedChanges: 'Aveți modificări nevalidate. Vă rugăm să validați din nou înainte de a adăuga în coș.',
    revalidate: 'Validează din nou',
    validating: 'Se validează...',
    validationSuccess: 'Toate articolele sunt valide',
    validationComplete: 'Validare finalizată',
    validationResultSummary: '{errors} erori, {warnings} avertismente găsite',
    // Table headers
    actions: 'Acțiuni',
    notes: 'Note',
    // Status filter
    all: 'Toate',
    hasErrors: 'Are erori',
    // Selection summary
    selected: 'selectat',
    errors: 'erori',
    // Pagination
    page: 'Pagina {current} din {total}',
    previous: 'Anterior',
    next: 'Următor',
    noResults: 'Niciun rezultat.',
    // Cart integration
    noValidItems: 'Niciun articol valid',
    allItemsHaveErrors: 'Toate articolele au erori de validare. Vă rugăm să le corectați înainte de a continua.',
    dataLoadingError: 'Eroare încărcare date',
    failedToLoadProductData: 'Nu s-au putut încărca datele produselor. Vă rugăm să reîncercați.',
    itemsAddedToCart: '{count} articole adăugate în coș',
    itemsAddedMessage: 'S-au adăugat {count} articole în coș',
    someSkusNotFound: '{count} SKU-uri nu au putut fi găsite.',
    noItemsAdded: 'Niciun articol adăugat',
    couldNotFindProducts: 'Nu s-a găsit niciun produs care să corespundă SKU-urilor.',
    errorAddingToCart: 'Eroare',
    failedToAddToCart: 'Nu s-au putut adăuga articolele în coș. Vă rugăm să reîncercați.',
    addingToCart: 'Se adaugă în coș...',
    // File info
    fileSelected: '{name} selectat pentru procesare',
    fileSize: '{size} bytes',
    fileSizeKB: '{size} KB',
    fileSizeMB: '{size} MB',
    // Template download
    templateDownload: 'Descărcare șablon',
    templateWillBeImplemented: 'Descărcarea șablonului va fi implementată în faza 7',
    // Additional validation
    validationFailed: 'Validare eșuată',
    // Template download
    templateDownloaded: 'Șablon descărcat cu succes',
    templateDownloadError: 'Nu s-a putut descărca șablonul',
    // Template content
    sheetName: 'ComandăMasivă',
    instructionsSheetName: 'Instructuini',
    columnDescriptions: 'Descrieri coloane:',
    columnHeader: 'Coloană',
    columnRequired: 'Obligatoriu',
    columnOptional: 'Opțional',
    columnDescription: 'Descriere',
    templateNotes: 'Note:',
    templateNote1: 'Prima linie trebuie să conțină antetele coloanelor exact așa cum apar',
    templateNote2: 'Datele încep de la rândul 2',
    templateNote3: 'SKU-ul trebuie să corespundă codurilor de produse existente în sistem',
    templateNote4: 'Cantitatea trebuie să fie un număr întreg pozitiv între 1 și 9999',
    templateNote5: 'Maximum 1000 de rânduri permise pe fișier',
    templateNote6: 'Salvați în format .xlsx sau .csv',
    stockAvailabilityWarning: 'Disponibilitatea reală a stocului va fi verificată la pagina următoare de finalizare.',
    outOfStock: 'Stoc epuizat',
    insufficientStock: 'Stoc insuficient: {available} disponibile, {requested} solicitate',
  },
  orderExport: {
    export: 'Exportă comanda',
    exportOrder: 'Exportă datele comenzii',
    exportAsCSV: 'Exportă ca CSV',
    exportAsExcel: 'Exportă ca Excel',
    exportForReorder: 'Exportă pentru import masiv',
    detailed: 'Detalii complete',
    simpleFormat: 'Format import',
  },
};
